import FeaturesListPresenter from "../components/features-list/presenter/features-list.js";

const items = document.querySelectorAll(`.product-feature-item`);

if (items.length > 0) {
  const featuresListComponent = new FeaturesListPresenter(items);
  featuresListComponent.init();
}
